import { render, staticRenderFns } from "./RegistComponent.vue?vue&type=template&id=50ea99f2&scoped=true&"
import script from "./RegistComponent.vue?vue&type=script&lang=js&"
export * from "./RegistComponent.vue?vue&type=script&lang=js&"
import style0 from "./RegistComponent.vue?vue&type=style&index=0&id=50ea99f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ea99f2",
  null
  
)

export default component.exports